'use client'

import { Button } from '@/components/ui/button'

export default function ManageBillingButton() {
  return (
    <Button
      variant="secondary"
      onClick={async () => {
        try {
          const r = await fetch('/api/stripe/portal', { method: 'POST' })
          if (!r.ok) throw new Error(await r.text())
          const { url } = await r.json()
          window.location.href = url
        } catch (e: any) {
          alert(`Open portal failed: ${e.message}`)
        }
      }}
    >
      Manage billing
    </Button>
  )
}
